import type { PriorityData, PriorityOption, Option } from './types.tsx';

export const mapDataToOptions = (data: PriorityData): Option[] =>
	data.map(({ id, name, iconUrl }) => ({ label: name, value: id, iconUrl }));

export const mapOptionToData = ({ label, value, iconUrl }: Option): PriorityOption => ({
	id: value,
	name: label,
	iconUrl,
});
